export const SUPERADMIN_ROUTES = {
  DASHBOARD_CONFIG: '/backoffice/config/dashboard/' as const,
};
